"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableColumn = SortableColumn;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
/**
 * Table column header that can be clicked to sort. Shows an up or down arrow for the
 * active sort column and a faint two-way arrow on the others so users can tell the
 * column is sortable before they click it.
 */
function SortableColumn(props) {
    var id = props.id, label = props.label, _a = props.isRowHeader, isRowHeader = _a === void 0 ? false : _a;
    return ((0, jsx_runtime_1.jsx)(react_1.Table.Column, { id: id, isRowHeader: isRowHeader, allowsSorting: true, children: function (_a) {
            var sortDirection = _a.sortDirection;
            return ((0, jsx_runtime_1.jsxs)("span", { className: "inline-flex items-center gap-1", children: [label, sortDirection === "ascending" ? ((0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:alt-arrow-up-linear", fontSize: 14, "aria-hidden": "true" })) : sortDirection === "descending" ? ((0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:alt-arrow-down-linear", fontSize: 14, "aria-hidden": "true" })) : ((0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:sort-vertical-linear", fontSize: 14, className: "opacity-40", "aria-hidden": "true" }))] }));
        } }));
}
